const templateUrl = require('./cancel-subscription.html');

module.exports = function($stateProvider) {
  $stateProvider.state('cancel', {
    parent: 'root',
    params: {
      subscription: {}
    },
    onEnter: ['$uibModal', 'subscriptionService', '$state', '$stateParams', '$document', 'tracking',
      ($uibModal, subscriptionService, $state, $stateParams, $document, trackingService) => {
        const modal = $uibModal.open({
          templateUrl: templateUrl,
          controller: require('./cancel-subscription.controller'),
          controllerAs: '$ctrl',
          backdrop: true,
          resolve: {
            reasons: () => subscriptionService.getCancelReasons()
          },
          windowTopClass: 'og-cancel-sub-modal',
          ariaLabelledBy: 'og-cancel-subscription-modal-title'
        });

        const track = name => trackingService.trackEvent(name, { subscriptionId: $stateParams.subscription.publicId });
        modal.opened.then(() => track('og_msi_cancel_button_click'));
        modal.closed.then(() => track('og_msi_cancel_modal_close'));

        modal.rendered.then(() => $document[0].querySelector('.og-modal-window').setAttribute('aria-modal', true));

        modal.result.catch(() => $state.go('root'));

        return modal;
      }]
  });
};

module.exports.$inject = ['$stateProvider'];
